module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "widget column",
    attrs: {
      "to": _vm.area + '/' + _vm.metric.name
    }
  }, [(_vm.metricData.type === 'bars') ? _c('metric-bar-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : (_vm.metricData.type === 'lines') ? _c('metric-line-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : (_vm.metricData.type === 'list') ? _c('metric-list-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1e108ef9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetricWidget.vue
// module id = 383
// module chunks = 1